export default "__VITE_ASSET__DtGReKUh__"